import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';
import { Button, Popover } from '@salesforce/design-system-react';

import './SelectionRules.scss';

class SelectionRules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rulesPopupIsOpen: false
    };
  }

  handlePopupOpen(fieldState) {
    this.setState({ [fieldState]: true });
  }

  handlePopupClose(fieldState) {
    this.setState({ [fieldState]: false });
  }

  getFatigueValue(val) {
    const { formatMessage } = this.props.intl;
    const ruleImmediate = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.immediate'
    });
    const ruleNever = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.never'
    });

    if (val === 0) {
      return ruleImmediate;
    } else if (val === -1) {
      return ruleNever;
    } else {
      return val;
    }
  }

  getLifetimeMax(val) {
    const { formatMessage } = this.props.intl;
    const unlimited = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.unlimited'
    });
    const times = formatMessage(
      {
        id: 'components.ecs.selectionBrowser.details.rules.times'
      },
      { times: val || 0 }
    );

    return val > 0 ? times : unlimited;
  }

  renderMustMatch() {
    const { formatMessage } = this.props.intl;
    const items = this.props.block?.selection?.context?.rules?.classifier;
    const matchTrue = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.ruleTrue'
    });
    const matchFalse = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.ruleFalse'
    });

    return (
      <div className="rule-container">
        <span className="rule-header slds-grid">
          <FormattedMessage id="components.ecs.selectionBrowser.details.rules.mustmatch.rule" />
        </span>
        <div className="must-match-border">
          <table className="must-match slds-table slds-table_cell-buffer slds-no-row-hover slds-table_bordered">
            <thead>
              <tr className="slds-line-height_reset">
                <th className="" scope="col">
                  <div className="slds-form-element__label">
                    {formatMessage({
                      id:
                        'components.ecs.selectionBrowser.details.rules.mustmatch.asset'
                    })}
                  </div>
                </th>
                <th className="" scope="col">
                  <div className="slds-form-element__label">
                    {formatMessage({
                      id:
                        'components.ecs.selectionBrowser.details.rules.mustmatch.profile'
                    })}
                  </div>
                </th>
                <th className="" scope="col">
                  <div className="slds-form-element__label">
                    {formatMessage({
                      id:
                        'components.ecs.selectionBrowser.details.rules.mustmatch.matchSetting'
                    })}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map(item => {
                const must_match = item.must_match ? matchTrue : matchFalse;
                return (
                  <tr className="slds-hint-parent">
                    <th scope="row">
                      <div className="slds-form-element__label">
                        {item.asset_key}
                      </div>
                    </th>
                    <td>
                      <div className="slds-form-element__label">
                        {item.profile_key}
                      </div>
                    </td>
                    <td>
                      <div className="slds-form-element__label">
                        {must_match}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderExclusion() {
    const { formatMessage } = this.props.intl;
    const items = this.props.block?.selection?.context?.rules?.exclusion;
    const assetAttribute = formatMessage({
      id:
        'components.ecs.selectionBrowser.details.rules.exclusion.assetAttribute'
    });
    const profileAttribute = formatMessage({
      id:
        'components.ecs.selectionBrowser.details.rules.exclusion.profileAttribute'
    });
    const equals = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.exclusion.equals'
    });
    const and = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.exclusion.and'
    });

    return (
      <div className="rule-container">
        <span className="rule-header slds-grid">
          <FormattedMessage id="components.ecs.selectionBrowser.details.rules.exclusion.rule" />
        </span>
        <p className="exclusion-description">
          <FormattedMessage id="components.ecs.selectionBrowser.details.rules.exclusion.description" />
        </p>
        {items.map(item => {
          return (
            <div className="rule-list slds-box">
              {assetAttribute} {item.asset_key} {equals} {item.asset_value}
              <div className="exclusion-profile slds-box">
                <span>{and}</span> {profileAttribute} {item.profile_key}{' '}
                {equals} {item.profile_value}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderFatigue() {
    const { formatMessage } = this.props.intl;
    const class_name = this.props.block?.asset_class?.name;
    const fatigueTrue = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.ruleTrue'
    });
    const fatigueFalse = formatMessage({
      id: 'components.ecs.selectionBrowser.details.rules.ruleFalse'
    });

    var items = _(this.props.block?.selection?.context?.rules?.fatigue)
      .groupBy('asset_type')
      .map(_.spread(_.assign))
      .value();
    let item = {};
    if (class_name) {
      item = items.filter(function(rule) {
        return rule.asset_type === class_name;
      });
    }
    if (item.length === 0) {
      item = items.filter(function(rule) {
        return rule.asset_type === 'default';
      });
    }

    const open = this.getFatigueValue(item[0].open);
    const click = this.getFatigueValue(item[0].click);
    const relax_fatigue =
      this.props.block?.selection?.context?.rules?.settings?.relax_fatigue ===
      true
        ? fatigueTrue
        : fatigueFalse;

    const selectMax = this.getLifetimeMax(item[0].max_select);
    return (
      <div className="rule-container">
        <span className="rule-header slds-grid">
          <FormattedMessage id="components.ecs.selectionBrowser.details.rules.fatigue.rule" />
        </span>
        <div className="rule-list">
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.details.rules.fatigue.relaxFatigue" />
          </span>
          <p>{relax_fatigue}</p>
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.details.rules.fatigue.selection" />
          </span>
          <p>{open}</p>
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.details.rules.fatigue.click" />
          </span>
          <p>{click}</p>
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.details.rules.fatigue.selectionMax" />
          </span>
          <p>{selectMax}</p>
        </div>
      </div>
    );
  }

  renderVariety() {
    return (
      <div className="rule-container">
        <span className="rule-header slds-grid">
          <FormattedMessage id="components.ecs.selectionBrowser.details.rules.variety.rule" />
        </span>
        <div className="rule-list">
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.details.rules.variety.label" />
          </span>
          <p>
            {this.props.block?.selection?.context?.rules?.variety?.attribute}
          </p>
        </div>
      </div>
    );
  }

  renderSpotlight() {
    return (
      <div className="rule-container">
        <span className="rule-header slds-grid">
          <FormattedMessage id="components.ecs.selectionBrowser.details.rules.spotlight.rule" />
        </span>
        <div className="rule-list">
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.details.rules.spotlight.attribute" />
          </span>
          <p>{this.props.block?.spotlight?.asset_key}</p>
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.details.rules.spotlight.attributeValue" />
          </span>
          <p>{this.props.block?.spotlight?.asset_value}</p>
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const ruleBody = (
      <div className="rules-container">
        {this.props.block?.selection?.context?.rules?.classifier?.length > 0
          ? this.renderMustMatch()
          : null}
        {this.props.block?.selection?.context?.rules?.exclusion?.length > 0
          ? this.renderExclusion()
          : null}
        {this.props.block?.selection?.context?.rules?.fatigue?.length > 0
          ? this.renderFatigue()
          : null}
        {this.props.block?.selection?.context?.rules?.variety?.attribute
          ?.length > 0
          ? this.renderVariety()
          : null}
        {this.props.block?.spotlight ? this.renderSpotlight() : null}
      </div>
    );

    return (
      <div className="selection-details-rules">
        <Popover
          align="right top"
          className="slds-text-align_left rules-popover"
          isOpen={this.state.rulesPopupIsOpen}
          body={ruleBody}
          heading={formatMessage({
            id: 'components.ecs.selectionBrowser.details.rules.header'
          })}
          id="selection-details-rules-popover"
          onClose={() => this.handlePopupClose('rulesPopupIsOpen')}
          onRequestClose={() => this.handlePopupClose('rulesPopupIsOpen')}
        >
          <Button
            variant="base"
            label={formatMessage({
              id: 'components.ecs.selectionBrowser.details.selectionRules'
            })}
            onClick={() => this.handlePopupOpen('rulesPopupIsOpen')}
          />
        </Popover>
      </div>
    );
  }
}

SelectionRules.contextTypes = {
  router: PropTypes.object
};

SelectionRules.propTypes = {
  actions: PropTypes.object,
  block: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(SelectionRules);
